import type { HealthCheckState } from 'client/js/main/types/healthCheckTypes';
import * as R from 'ramda';
import { DUPLICATE_DATA_SOURCES, IS_EVENT_INGESTION_HEALTHY } from '../actions/HealthCheckActions';
import { reducerWrapper } from '../support/utils';

const INIT_STATE: HealthCheckState = {
  isEventIngestionHealthy: null,
  duplicateDataSources: [],
};

function Handler(state: HealthCheckState = INIT_STATE, action): HealthCheckState {
  switch (action.type) {
    case IS_EVENT_INGESTION_HEALTHY.response:
      return R.merge(state, {
        isEventIngestionHealthy: action.data,
      });

    case DUPLICATE_DATA_SOURCES.response:
      return R.merge(state, {
        duplicateDataSources: action.data,
      });

    default:
      return state;
  }
}

const HealthCheckReducer = reducerWrapper(INIT_STATE, Handler, {
  resetOn: ['APP_CHANGE'],
});
export default HealthCheckReducer;
